export default "__VITE_ASSET__vANgZ2jj__"